import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonInverted = styled(Button).attrs({
  variant: 'outlined',
})`
  min-width: 112px;
  min-height: 36px;
  padding: 0 16px;
  border-radius: var(--radius-md);
  border: 1px solid var(--primary-600);
  background-color: var(--neutral-0);
  color: var(--primary-600);
  font-family: inherit;
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.2px;
  text-transform: none;
  line-height: 1;
  transition:
    background-color var(--motion-fast) var(--ease-standard),
    color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  &:hover {
    background-color: var(--primary-50);
    border-color: var(--primary-700);
    color: var(--primary-700);
  }

  &:focus-visible {
    box-shadow: var(--shadow-focus);
  }

  &:active {
    background-color: var(--primary-100);
  }

  &.Mui-disabled {
    border-color: var(--neutral-200);
    color: var(--neutral-400);
    background-color: var(--neutral-0);
  }
`;

export default ButtonInverted;
